import React from 'react';
import { BiError, BiErrorCircle, BiInfoCircle } from 'react-icons/bi';
import { BsCheckCircle } from 'react-icons/bs';

export type IAlertType = {
  isShow: boolean;
  title?: string;
  message: string;
  type: IAlertPropsType['type'];
};

type IAlertPropsType = {
  type: 'success' | 'warning' | 'Error' | 'Info';
  children: any;
  className?: string;
  onClick?: () => void;
};

function Alert({ type, children, className, onClick }: IAlertPropsType) {
  let icon;
  let header;
  let _className;

  switch (type) {
    case 'success':
      icon = <BsCheckCircle color="#37A36E" size={20} className="tw-m-[2px]" />;
      header = <p className="m-0 font-sofiaSans tw-text-green-700 tw-text-xs tw-font-bold">Success</p>;
      _className =
        'tw-px-5 tw-py-3 tw-mb-5 tw-bg-emerald-50 tw-rounded-xl tw-flex tw-flex-col tw-items-start tw-gap-3 tw-border-solid tw-border-1 tw-border-green-300';
      break;
    case 'warning':
      icon = <BiErrorCircle color="#FDB139" size={24} />;
      header = <p className="m-0 font-sofiaSans tw-text-amber-700 tw-text-xs tw-font-bold">Warning</p>;
      _className =
        'tw-px-5 tw-py-3 tw-mb-5 tw-bg-orange-100 tw-rounded-xl tw-flex tw-flex-col tw-items-start tw-gap-3 tw-border-solid tw-border-1 tw-border-orange-300';
      break;
    case 'Error':
      icon = <BiError color="#E34A51" size={24} />;
      header = <p className="m-0 font-sofiaSans tw-text-red-600 tw-text-xs tw-font-bold">Error</p>;
      _className =
        'tw-px-5 tw-py-3 tw-mb-5 tw-bg-rose-50 tw-rounded-xl tw-flex tw-flex-col tw-items-start tw-gap-3 tw-border-solid tw-border-1 tw-border-rose-300';
      break;
    default:
      icon = <BiInfoCircle color="#6b7280" size={24} />;
      header = <p className="m-0 font-sofiaSans tw-text-gray-600 tw-text-xs tw-font-bold">Info</p>;
      _className =
        'tw-px-5 tw-py-3 tw-mb-5 tw-bg-slate-100 tw-rounded-xl tw-flex tw-flex-col tw-items-start tw-gap-3 tw-border-solid tw-border-1 tw-border-slate-300';
      break;
  }

  return (
    <div
      className={`${className ? className : ''} ${_className}`}
      onClick={onClick}
      onKeyDown={onClick ? e => e.key === 'Enter' && onClick() : undefined}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
    >
      <div className="tw-flex tw-gap-1 tw-items-center">
        {icon}
        <span>{header}</span>
      </div>
      <div className="font-sofiaSans tw-text-xs tw-font-bold tw-break-words">{children}</div>
    </div>
  );
}

export default Alert;
